import { render, staticRenderFns } from "./OrdersTopRight.vue?vue&type=template&id=3c4a75d4&scoped=true&"
import script from "./OrdersTopRight.vue?vue&type=script&lang=js&"
export * from "./OrdersTopRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a75d4",
  null
  
)

export default component.exports